import { render, staticRenderFns } from "./TrackerDataTableItemTitle.html?vue&type=template&id=593656f6&external"
import script from "./TrackerDataTableItemTitle.js?vue&type=script&lang=js&external"
export * from "./TrackerDataTableItemTitle.js?vue&type=script&lang=js&external"
import style0 from "./TrackerDataTableItemTitle.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem})
